export const GUEST_VALIDATE_MPIN = "GUEST_VALIDATE_MPIN";
export const GUEST_VALIDATE_MPIN_ERROR = "GUEST_VALIDATE_MPIN_ERROR";
export const GUEST_VALIDATE_MPIN_HIDE_ERROR = "GUEST_VALIDATE_MPIN_HIDE_ERROR";
export const GUEST_VALIDATE_MPIN_START_LOADER = "GUEST_VALIDATE_MPIN_START_LOADER";
export const GUEST_VALIDATE_MPIN_STOP_LOADER = "GUEST_VALIDATE_MPIN_STOP_LOADER";
